export default __webpack_public_path__ + "static/media/allery-3.fda840c5.svg";